import React, { useCallback } from "react";
import { VisibilityConditions } from "./EditBlock";
import Input from "../FormComponents/Input";

const EditPositionSection = ({ editElementData, setEditElementData, tableId, tableType }) => {
  const handleChange = useCallback(
    (key, value) => setEditElementData((prevData) => ({ ...prevData, [key]: value })),
    [setEditElementData]
  );

  const collapsible = editElementData.collapsible === true;
  const defaultOpen = editElementData.default_open !== false; // default true

  return (
    <div>
      <Input
        type="checkbox"
        label="Collapsible section"
        name="collapsible"
        checked={collapsible}
        onChange={(e) => handleChange("collapsible", e.target.checked)}
      />

      {collapsible && (
        <>
          <Input
            type="text"
            label="Section title"
            id="collapse_title"
            name="collapse_title"
            value={editElementData.collapse_title || ""}
            onChange={(e) => handleChange("collapse_title", e.target.value)}
          />
          <Input
            type="checkbox"
            label="Open by default"
            name="default_open"
            checked={defaultOpen}
            onChange={(e) => handleChange("default_open", e.target.checked)}
          />
        </>
      )}

      <VisibilityConditions
        visibility={editElementData.visibility || {}}
        onChange={(v) => handleChange("visibility", v)}
        tableId={tableId}
        tableType={tableType}
      />
    </div>
  );
};

export default EditPositionSection;
